import { Component, OnInit } from '@angular/core';
import { AlertType } from '../models/alert-type';
import { faCircleCheck, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent implements OnInit {

  AlertType = AlertType;
  faCircleCheck = faCircleCheck;
  faTriangleExclamation = faTriangleExclamation;
  faCircleInfo = faCircleInfo;

  message: string = '';
  type?: AlertType;
  dismissButton: boolean = false;
  className: string = 'alert-success';
  displayAlert: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  showAlert(alertData: {message: string | { message?: string }, type: AlertType, dismissButton: boolean}) {
    const raw = alertData.message;
    this.message = typeof raw === 'string' ? raw : (raw && typeof raw === 'object' && typeof raw.message === 'string' ? raw.message : String(raw ?? ''));
    this.type = alertData.type;
    this.dismissButton = alertData.dismissButton;
    this.displayAlert = true;

    switch(alertData.type) {
      case AlertType.SUCCESS:
        this.className = 'alert-success';
        break;
      case AlertType.ERROR:
        this.className = 'alert-danger';
        break;
      case AlertType.INFO:
        this.className = 'alert-primary';
        break;
      case AlertType.WARNING:
        this.className = 'alert-warning';
        break;
      default:
        this.className = 'alert-success';
        break;        
    }
  }

  removeAlert() {
    this.message = '';
    this.displayAlert = false;
  }
}
